export default (value: string | null) => {
  if (value === null) return true

  if (value.length < 6 || value.length > 6) {
    return "Sort code must have 6 digits"
  }

  return true
}
